<div class="page-body-container"
     (dbClickOutside)="resetSelection()">
    <db-builder-page-section
      *ngIf="staticSections[0]"
      (isEdit)="isEdit = $event"
      [section]="staticSections[0]"
      (click)="pageInteractionsService.closeAll()"
      [showPlus]="false"
      [canAddSection]="draggableSections.length < sectionsLimit"
      (onAddSection)="onAddSection(staticSections[0], 0)"
      [static]="true">
    </db-builder-page-section>
  <db-add-section-btn *ngIf="!draggableSections.length && !loading && !emptyPages.includes(page.page_type)"
                      (onAddSection)="onAddSection(staticSections[0], 0)">
  </db-add-section-btn>
  <db-product-list-section-placeholder *ngIf="emptyPages.includes(page.page_type)"></db-product-list-section-placeholder>
  <div [dragulaModel]="draggableSections"
       *ngIf="draggableSections.length && !emptyPages.includes(page.page_type)"
       class="draggable-sections"
       (dragulaModelChange)="onStructureChange($event)"
       [dragula]="page?.id?.toString()">
    @for (section of draggableSections; track section.id; let i = $index, count = $count) {
      <div class="page-section">
        <db-builder-page-section
          dbClassChangeObserver
          (classChanged)="elementClassChanged()"
          [section]="section"
          [selected]="selectedSection?.id === section.id"
          (isEdit)="isEdit = $event"
          [isDragging]="isDragging"
          [canAddSection]="count < sectionsLimit"
          [loading]="loading"
          (valueChange)="sectionValueChanged($event, i)"
          (onGenerate)="onGenerate(i, $event)"
          (contextmenu)="rightClick($event, section, i)"
          (click)="selectSection(section, i)"
          (onAddSection)="onAddSection(section, i)">
        </db-builder-page-section>
        <db-builder-page-section
          *ngIf="temprorarySection && temprorarySection?.index === (i + 1)"
          [section]="temprorarySection">
        </db-builder-page-section>
      </div>
    }
  </div>
  <db-builder-page-section [section]="staticSections[1]"
                           (isEdit)="isEdit = $event"
                           (click)="pageInteractionsService.closeAll()"
                           [showPlus]="false"
                           *ngIf="staticSections[1]"
                           [selected]="selectedSection?.id === staticSections[1].id"
                           [static]="true">
  </db-builder-page-section>
  <db-sceleton-loading *ngIf="loading"></db-sceleton-loading>
</div>
